// エラー報告用のユーティリティ関数
export function reportError(error: Error, context?: Record<string, unknown>) {
  console.error('Reported error:', error, context);

  if (import.meta.env.PROD) {
    // TODO: エラートラッキングサービスへの送信
    // errorTracker.captureException(error, { extra: context })
  }
}
